<template>
  <div>
    <div class="grid grid-cols-1 gap-2">

      <InputText v-model="newComponentStore.newComponent.title"
        :label="$t('newcomponent.chart.chart.preview.title')" name="title" />
    </div>

    <div class="mt-2">
      <SalesCardPreview />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useNewComponentStore } from '../../stores/newComponentStore'
// import InputCheckbox from '../../components/form/input/InputCheckbox.vue';
import SalesCardPreview from '../../components/SalesCardPreview.vue';
const newComponentStore = useNewComponentStore();
import InputText from './input/InputText.vue';
</script>